import { alpha } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  container: {
    backgroundColor: alpha(theme.palette.grey[50], 0.8),
  },
  share: {
    textAlign: 'right',
  },
  shareWrapper: {
    display: 'inline-block',
  },
  mobileShare: {
    flexDirection: 'column !important' as 'column',
  },
}))
